/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { UploadImgStyle } from '../Chat/index.style'
import AdvImg from '@components/AdvImg'

const ProfileImgViewPopup: React.FC = () => {
  const { globalStore, authStore } = useRootStore()
  const { visibleProfileImgViewPopup } = globalStore
  const { userInfo, signedin } = authStore

  const onClickClose = () => {
    globalStore.setVisibleProfileImgViewPopup(false)
  }

  let userProfileImg = null
  if (signedin) {
    userProfileImg = (
      <div css={UploadImgStyle}>
        <AdvImg src={userInfo.avatar} srcMode={'small'} alt="프로필 이미지"/>
      </div>
    )
  }

  return (
    <Modal
      popup
      maskClosable={false}
      visible={visibleProfileImgViewPopup}
      animated={isMobile}
      animationType="slide-up"
      title={
        <Fragment>
          <h1 className="title">프로필 이미지</h1>
          <Button onClick={onClickClose} className="close-btn" css={CloseBtn}>
            <span className="close-txt">닫기</span>
          </Button>
        </Fragment>
      }
      className="full-modal"
      onClose={onClickClose}
    >
      {userProfileImg}
      <ModalBg onClick={onClickClose}/>
    </Modal>
  )
}

// 더이상 사용하지 않는 풀팝업
export default observer(ProfileImgViewPopup)

